import api from './api';

/**
 * Customer privacy choices -- `/api/v1/communications/privacy-preferences/` and
 * `/consent-log/` (board #347 phase 1). Marketing opt-outs only; transactional
 * and statutory messages are not affected by these switches.
 */

export type MarketingChannel = 'email' | 'sms' | 'whatsapp' | 'push';

export interface PrivacyPreferences {
  channels: MarketingChannel[];
  delivering: MarketingChannel[];
  preferences: { marketing: Record<MarketingChannel, boolean> };
  applies_to: 'marketing';
  transactional_unaffected: boolean;
}

export interface ConsentLogEntry {
  id: string;
  consent_type: string;
  granted: boolean;
  policy_version: string;
  source: string;
  created_at: string;
}

export const privacyPreferencesApi = {
  async get(): Promise<PrivacyPreferences> {
    const { data } = await api.get<PrivacyPreferences>('/communications/privacy-preferences/');
    return data;
  },

  async update(marketing: Partial<Record<MarketingChannel, boolean>>): Promise<PrivacyPreferences> {
    const { data } = await api.put<PrivacyPreferences>('/communications/privacy-preferences/', {
      preferences: { marketing },
    });
    return data;
  },

  async consentLog(): Promise<ConsentLogEntry[]> {
    const { data } = await api.get<{ results: ConsentLogEntry[] }>('/communications/consent-log/');
    return data.results;
  },
};
